/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { SchedulingOptionsViewModel } from './SchedulingOptionsViewModel'; 

export function getSchedulingOptionsOptions(onSuccess?: (result: SchedulingOptionsViewModel) => void) {
	return queryOptions({
		queryKey: ['scheduling-options'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/legacy/scheduling/queries/getschedulingoptions/';
			const resp = await axios.get<SchedulingOptionsViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}